<template>
<div>
  <el-input :value="name" maxlength="50" :readonly="true">
    <el-button slot="prepend" icon="el-icon-s-promotion"  @click="showDrawer"></el-button>
  </el-input>
  <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="objtype" :menukeyArray="menukeyArray"></drawerViews>
</div>
</template>

<script>
import elDragDialog from '@/directive/el-dragDialog';
import request from '@/utils/request';

export default {
  name: 'show-form-detailed',
  directives: { elDragDialog },
  props: {
    id: {
      type: String
    },
    name: {
      type: String
    },
    apiName: {
      type: String,
      required: true
    },
    otherMenukeyArray: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      drawer: false,
      drawertemp: {}
    };
  },
  computed: {
    menukeyArray() {
      const tempmenkeyArray = [];
      tempmenkeyArray.push({ name: '基本信息', menukey: this.apiName.toLowerCase() + 'view' });
      if (this.otherMenukeyArray.length > 0) {
        tempmenkeyArray.push(...this.otherMenukeyArray);
      }
      return tempmenkeyArray;
    },
    objtype() {
      return this.apiName.substring(0, 1).toUpperCase() + this.apiName.substring(1);
    }
  },
  methods: {
    showDrawer() {
      if (this.id !== '' && this.name !== '') {
        this.getByApi(this.id).then(response => {
          if (response.result !== null) {
            this.drawertemp = { ...this.drawertemp, ...response.result };
            this.drawer = true;
          }
        }).catch(() => {
          // console.log(err)
        });
      }
    },
    getByApi(id) {
      return request({
        url: '/' + this.apiName + '/get',
        method: 'get',
        params: { id: id }
      });
    }
  }
};
</script>
<style>
  .el-autocomplete {
    width: 100%;
  }
</style>
